import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import ArrowButton from '../common/button-arrow';
import Reward from './reward';
import RedeemModal from './redeem-modal';
import { history } from '../../store';
import {checkPermission} from '../common/guards/can';

import './my-rewards.css';
import MyRewardsStaffMembers from './my-rewards-staff-members';

class MyRewards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redeemModalActive: false,
      individualRewards: null,
      isRedeemFundsDisabled: false
    };
  }

  componentDidMount() {
    this.setRewardData(this.props.individualRewards);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.individualRewards.order['transfer_amount'] !== this.props.individualRewards.order['transfer_amount']) {
      this.setRewardData(nextProps.individualRewards);
    }
  }

  handleRedeemFundsModal = () => {
    const { redeemModalActive } = this.state;

    this.setState({ redeemModalActive: !redeemModalActive });
  };

  setRewardData = (individualRewards) => {

    this.setState({
      reward: {
        voucher: individualRewards.voucher,
        maxVoucherValue: individualRewards['max_voucher_value'],
        maxVouchersForDuration: individualRewards['max_vouchers_for_duration'],
        order: {
          nextOrderAmount: individualRewards.order['next_order_amount'],
          totalVouchersAvailable: individualRewards.order['total_vouchers_available'],
          vouchersRedeemed: individualRewards.order['vouchers_redeemed'],
          individualBalance: individualRewards.order['individual_balance'],
          transferAmount: individualRewards.order['transfer_amount']
        }
      },
      address1: individualRewards['address_1'],
      address2: individualRewards['address_2'],
      address3: individualRewards['address_3'],
      eircode: individualRewards['eircode']
    }, () => {
      const { reward: { order } } = this.state;

      this.setIsRedeemFundsDisabled(order);
    });
  };

  setNextOrderAmount = (nextOrderAmount, individualBalance) => {
    const { reward } = this.state;
 
    this.setState({
      reward: {
        ...reward,
        order: {
          ...reward.order,
          nextOrderAmount,
          individualBalance,
        }
      }
    });
  }

  setRewardDataAfterRedeem = (order) => {
    let newReward = this.state.reward;
    newReward.order = order;

    this.setState({
      reward: newReward
    }, () => {
      this.setIsRedeemFundsDisabled(order);
    });
  };

  setIsRedeemFundsDisabled = (order) => {
    this.setState({ isRedeemFundsDisabled: !(order.nextOrderAmount > 0 && order.vouchersRedeemed < order.totalVouchersAvailable) });
  };

  handleNavigateToMyStaff = () => {
    history.push('/my-staff');
  };

  render() {
    const { userGroup, staffMembers } = this.props;
    const {
      reward, redeemModalActive,
      address1, address2, address3, eircode, isRedeemFundsDisabled
    } = this.state;
    const hasStaffMembers = staffMembers.length > 0;

    return (
      <div className="my-rewards">
        {reward && (
          <div>
            <div className="my-rewards-container">
              <Reward
                image={reward.voucher.links.photo}
                name={reward.voucher.name}
                redeemed={reward.order.vouchersRedeemed}
                available={reward.order.totalVouchersAvailable}
                nextAmount={reward.order.nextOrderAmount}
                individualBalance={reward.order.individualBalance}
                transferAmount={reward.order.transferAmount}
                address1={address1}
                address2={address2}
                address3={address3}
                eircode={eircode}
                hasStaffMembers={hasStaffMembers} />
              <div className="my-rewards-buttons-container">
                { checkPermission('handle', 'staff_rewards') && (<div onClick={() => this.handleRedeemFundsModal()} className="my-rewards-button">
                  <ArrowButton arrow={false} color='green' submit={false} disabled={isRedeemFundsDisabled}>
                    REDEEM FUNDS NOW
                  </ArrowButton>
                </div>) }
                <Link to={'/points-statement#staff'} className="my-rewards-button">
                  <ArrowButton arrow={false} color='red' submit={false}>MY POINTS STATEMENT</ArrowButton>
                </Link>
              </div>
              {userGroup === "owner" && checkPermission('handle', 'staff_rewards') &&
                <MyRewardsStaffMembers staffMembers={staffMembers} setNextOrderAmount={this.setNextOrderAmount} />}
              {!hasStaffMembers && <div>
                <div className="my-rewards-info-row-message">
                  This outlet does not have any staff members.
                </div>
                <Button
                  className="btn grey-ghost-btn text-uppercase my-reward-info-address-button"
                  onClick={this.handleNavigateToMyStaff}>
                  Add staff member
                </Button>
              </div>}
            </div>
            <RedeemModal
              handleRedeemFundsModal={this.handleRedeemFundsModal}
              redeemModalActive={redeemModalActive}
              maxMonetaryValue={reward.order.nextOrderAmount}
              maxVouchersAllowed={reward.order.totalVouchersAvailable}
              setRewardDataAfterRedeem={this.setRewardDataAfterRedeem}
              maxVouchersForDuration={reward.maxVouchersForDuration}
              maxVoucherValue={reward.maxVoucherValue} />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userGroup: state.viewConfig.profile.attributes['user-group'],
    defaultStore: state.viewConfig.profile.attributes["default-outlet-id"],
    individualRewards: state.rewards.individualRewards
  };
};

export default connect(mapStateToProps)(MyRewards);



// WEBPACK FOOTER //
// ./src/components/my-rewards/my-rewards.jsx